import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { nFormatter } from "../../../Helpers";
import CurrencySymbol from "../../../Components/common/CurrencySymbol";
import { ExdInfoTip, EXD_TOOLTIP_PROPS } from "./ExdControls";
import {
  getKpiTheme,
  KpiCardShell,
  KpiCardValue,
  KpiHeader,
  KpiMeter,
  KpiPill,
  KpiSkeleton,
  KpiSubRow,
} from "./kpiMui";

const formatFullAmount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const SalesVsTargetCard = ({
  title,
  saleAmount,
  targetAmount,
  targetLabel,
  infoTitle,
  loading,
  translate,
  loginUserCurrency,
  accent = "revenue",
}) => {
  if (loading) return <KpiSkeleton />;

  const theme = getKpiTheme(accent);
  const sale = Number(saleAmount) || 0;
  const target = Number(targetAmount) || 0;
  const achieved = sale > target;
  const pctNum = target ? (sale / target) * 100 : 0;
  const percent = Number.isFinite(pctNum) ? `${pctNum.toFixed(0)}%` : "0%";
  const progressValue = achieved ? 100 : Math.min(Math.max(pctNum, 0), 100);
  const pillVariant = !target
    ? "warn"
    : achieved
      ? "good"
      : pctNum < 50
        ? "bad"
        : "neutral";
  const onDark = theme.infoTone === "onDark";

  return (
    <KpiCardShell accent={accent}>
      <KpiHeader
        title={title}
        info={<ExdInfoTip title={infoTitle} tone={theme.infoTone} />}
      />

      <Tooltip {...EXD_TOOLTIP_PROPS} title={formatFullAmount(saleAmount)}>
        <Box sx={{ display: "inline-block", maxWidth: "100%" }}>
          <KpiCardValue theme={theme}>
            {saleAmount ? nFormatter(saleAmount, 2) : 0}
            <Box component="small">
              <CurrencySymbol
                currency={loginUserCurrency}
                withParentheses={false}
              />
            </Box>
          </KpiCardValue>
        </Box>
      </Tooltip>

      <KpiMeter value={progressValue} theme={theme} />

      <KpiSubRow sx={{ color: theme.muted }}>
        <Tooltip
          {...EXD_TOOLTIP_PROPS}
          title={`${targetLabel}: ${formatFullAmount(targetAmount)}`}
        >
          <Typography
            component="span"
            sx={{
              fontSize: "inherit",
              color: "inherit",
              cursor: "default",
              display: "inline-block",
            }}
          >
            {targetLabel}{" "}
            <Box component="b" sx={{ color: theme.color }}>
              {targetAmount ? nFormatter(targetAmount, 2) : 0}
            </Box>
          </Typography>
        </Tooltip>
        <KpiPill variant={pillVariant} onDark={onDark}>
          {!target
            ? "No target set"
            : achieved
              ? translate("Target Achieved")
              : `${percent} ${translate("Achieved")}`}
        </KpiPill>
      </KpiSubRow>
    </KpiCardShell>
  );
};

export default SalesVsTargetCard;
